import { render, staticRenderFns } from "./AddGroup.vue?vue&type=template&id=c87d442e&scoped=true&lang=pug&"
import script from "./AddGroup.vue?vue&type=script&lang=js&"
export * from "./AddGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87d442e",
  null
  
)

export default component.exports